var _circle, _rect, _g, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllEkycRequired(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 329 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 164.281,
    cy: 100.365,
    r: 76.3416,
    fill: "#9AA0DA",
    fillOpacity: 0.14
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6561_32467",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 5,
    width: 111,
    height: 187
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 107.524,
    y: 16.3926,
    width: 87.909,
    height: 178.926,
    rx: 13.3195,
    transform: "rotate(-8.5433 107.524 16.3926)",
    fill: "#6B748D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6561_32467)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.524,
    y: 16.3926,
    width: 87.909,
    height: 178.926,
    rx: 13.3195,
    transform: "rotate(-8.5433 107.524 16.3926)",
    fill: "url(#paint0_linear_6561_32467)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M113.147 29.9149C112.408 24.9969 112.039 22.538 112.714 20.5158C113.307 18.7371 114.449 17.1919 115.975 16.1018C117.709 14.8625 120.168 14.4932 125.086 13.7544L180.408 5.44379C185.326 4.70501 187.784 4.33561 189.807 5.01052C191.585 5.60419 193.131 6.74574 194.221 8.27155C195.46 10.0062 195.829 12.4651 196.568 17.383L218.512 163.458C218.992 166.654 219.232 168.253 218.794 169.567C218.408 170.723 217.666 171.728 216.674 172.436C215.546 173.242 213.948 173.482 210.751 173.962L150.513 183.011C145.595 183.75 143.136 184.12 141.114 183.445C139.335 182.851 137.79 181.709 136.7 180.184C135.46 178.449 135.091 175.99 134.352 171.072L113.147 29.9149Z",
    fill: "url(#paint1_linear_6561_32467)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M111.201 16.9626C111.11 16.3564 111.528 15.7912 112.134 15.7001L193.127 3.53304C193.862 3.42265 194.547 3.92885 194.657 4.66365C194.729 5.14127 194.4 5.58663 193.922 5.65838L112.464 17.8954C111.858 17.9865 111.292 17.5688 111.201 16.9626Z",
    fill: "#C7C8CC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 15.0955,
    height: 3.10789,
    rx: 1.55395,
    transform: "matrix(0.988904 -0.148557 -0.148557 -0.988904 171.501 185.246)",
    fill: "url(#paint2_linear_6561_32467)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 116.877,
    y: 20.3752,
    width: 73.7015,
    height: 145.849,
    rx: 7.10376,
    transform: "rotate(-8.5433 116.877 20.3752)",
    fill: "#231C45"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 107.524,
    y: 16.3926,
    width: 87.909,
    height: 178.926,
    rx: 13.3195,
    transform: "rotate(-8.5433 107.524 16.3926)",
    fill: "url(#paint3_linear_6561_32467)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.216 80.6019C144.216 80.6019 145.792 79.9267 149.085 79.4321C152.377 78.9374 153.952 79.1395 153.952 79.1395",
    stroke: "#BCD4FF",
    strokeWidth: 3.51864,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.097 76.4127C172.097 76.4127 173.672 75.7375 176.965 75.2429C180.258 74.7482 181.832 74.9503 181.832 74.9503",
    stroke: "#BCD4FF",
    strokeWidth: 3.51864,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.826 100.216C138.826 100.216 139.702 98.2221 143.303 97.6834C145.12 97.4117 147.933 99.4894 150.339 98.8524C152.486 98.2837 155.597 96.5534 158.104 96.021C160.49 95.5143 163.967 96.806 166.563 96.4162C169.427 95.9861 172.005 93.2096 174.657 92.9751C177.163 92.7535 178.758 93.9891 180.921 93.8948C183.339 93.7894 185.908 91.3211 187.663 91.0219C191.05 90.4448 192.609 91.9354 192.609 91.9354",
    stroke: "#BCD4FF",
    strokeWidth: 3.51864,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M178.576 56.5679L177.742 45.5382",
    stroke: "#8D99FF",
    strokeWidth: 3.51864,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M184.358 54.3585L183.705 45.8231",
    stroke: "#8D99FF",
    strokeWidth: 3.51864,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190.279 55.0128L189.545 46.2724",
    stroke: "#8D99FF",
    strokeWidth: 3.51864,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M214.072 16.2112C217.589 14.1178 222.115 15.2336 224.18 18.7033C226.245 22.173 225.067 26.6827 221.55 28.7761C216.195 31.9625 209.592 31.2892 206.474 30.7104C205.451 30.5204 204.853 29.5274 205.167 28.5354C206.118 25.5314 208.632 19.4488 214.072 16.2112Z",
    fill: "url(#paint4_linear_6561_32467)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M233.299 34.5019C237.344 35.1325 240.118 38.8778 239.496 42.8673C238.874 46.8567 235.091 49.5795 231.047 48.9489C224.89 47.989 220.233 43.2592 218.201 40.825C217.534 40.0263 217.706 38.88 218.581 38.3163C221.23 36.6092 227.044 33.5265 233.299 34.5019Z",
    fill: "url(#paint5_linear_6561_32467)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6561_32467",
    x1: 114.517,
    y1: 50.9124,
    x2: 260.921,
    y2: 103.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#535678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6561_32467",
    x1: 118.2,
    y1: 23.2069,
    x2: 213.245,
    y2: 166.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8890A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C758E",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6561_32467",
    x1: 7.54774,
    y1: 0,
    x2: 7.54774,
    y2: 3.10789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6561_32467",
    x1: 146.3,
    y1: 21.4273,
    x2: 145.801,
    y2: 90.7306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47C8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#47C8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47C8E9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6561_32467",
    x1: 224.07,
    y1: 31.7795,
    x2: 204.001,
    y2: 21.5132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34DCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6561_32467",
    x1: 231.073,
    y1: 52.8696,
    x2: 222.161,
    y2: 32.1635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34DCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F5F6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllEkycRequired);
export default __webpack_public_path__ + "static/media/ill-ekyc-required.86e23fd3ca893f848ee0af6e74266409.svg";
export { ForwardRef as ReactComponent };